/**
 * ZIEA Scroll Animations
 * Intersection Observer for smooth scroll animations
 */

(function() {
  'use strict';
  
  // Check if IntersectionObserver is supported
  if (!('IntersectionObserver' in window)) {
    // Fallback: Show all elements immediately
    document.querySelectorAll('[class*="animate-"]').forEach(function(el) {
      el.classList.add('is-visible');
    });
    return;
  }
  
  // Create intersection observer
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -100px 0px', // Trigger 100px before element enters viewport
    threshold: 0.1
  };
  
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // Unobserve after animation to improve performance
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  // Initialize on DOM ready
  function initScrollAnimations() {
    // Observe all elements with animation classes
    const animatedElements = document.querySelectorAll(
      '.animate-fade-in, .animate-slide-left, .animate-slide-right, .animate-scale, .animate-stagger'
    );
    
    animatedElements.forEach(function(el) {
      observer.observe(el);
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }
  
  // Re-initialize for dynamically loaded content
  window.zieaScrollAnimations = {
    refresh: function() {
      initScrollAnimations();
    }
  };
})();
